// extracted by mini-css-extract-plugin
export default {"RatingStarsContainer":"RatingStarsContainer__9H5Py","starContainer":"starContainer__S4KyD"};